export default __webpack_public_path__ + "static/sustainability-model-c8746ba4864255a5b1c313ee3d7cb8e5.jpg";